/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Train_BodyInputs */

const en_features_train_body = /** @type {(inputs: Features_Train_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach's plan sets the weight and the reps, the rest counts itself down, and what you did last time sits right beside it. The moment you finish, you know whether you got stronger.`)
};

const pl_features_train_body = /** @type {(inputs: Features_Train_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan od trenera podaje ciężar i powtórzenia, przerwa odlicza się sama, a obok widzisz, co zrobiłeś ostatnio. Po treningu od razu wiesz, czy jesteś mocniejszy.`)
};

/**
* | output |
* | --- |
* | "Your coach's plan sets the weight and the reps, the rest counts itself down, and what you did last time sits right beside it. The moment you finish, you know..." |
*
* @param {Features_Train_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_train_body = /** @type {((inputs?: Features_Train_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Train_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_train_body(inputs)
	return en_features_train_body(inputs)
});